export const baseUrl = "https://vending.339home.com";
export const apiUrl = "https://api.339home.com";
export const wsUrl = "wss://api.339home.com";

export const apiVersion = "v1.0";
export const apiNewVersion = "v1.1";

export const SentryDSN = "https://b0e55cd682f941c8a49fa8d919df31b8@o474560.ingest.sentry.io/5649681";

export const FacebookAppId = "";

export const GoogleMapKey = "AIzaSyBCERdmkUPU3LSwOAiy52-a-mmddaXzh3A";
export const GoogleClientId = "";

export const reCAPTCHAKey = "6LfCBsQUAAAAAHDYo3yjh2IMvi2BVlqgd9LCgghn";

export const DefaultMapCenter = {
    "lat": 22.331759,
    "lng": 114.088233,
};

export const roleMap = {
    "vending-admin": "管理員",
    "vending-vendor": "服務供應商",
    "vending-site-manager": "屋苑管理員",
};

export const TASK_STAGE_ENUM = [
    "ENQUIRY",
    "APPLICATION",
    "SITE_VISIT",
    "CONTRACT",
    "INSTALLATION",
    "COMPLETION",
];
